export default __webpack_public_path__ + "static/media/2.93000706.png";